import { createEmptyAnswers, type OnboardingBootstrap } from "./types";

const client = {
  clientId: "preview-northstar",
  brandName: "Northstar Heating & Air",
  contactFirstName: "Jamie",
  clientEmail: "jamie@northstarheating.example",
  cpName: "Yoojin",
  cpEmail: "yoojin@hvaclaunch.ai",
  website: "northstarheating.example",
  locations: [
    {
      id: "grand-forks",
      name: "Grand Forks",
      address: "1724 Gateway Drive, Grand Forks, ND 58203",
      licenseNumber: "ND-48291",
      marketName: "Greater Grand Forks",
      callsCoverage: "24-7" as const,
      callHours: "",
    },
    {
      id: "fargo",
      name: "Fargo",
      address: "4510 19th Avenue S, Fargo, ND 58103",
      licenseNumber: "ND-48291",
      marketName: "Fargo–Moorhead",
      callsCoverage: "custom" as const,
      callHours: "Mon–Fri 7am–7pm, Sat 8am–4pm",
    },
  ],
  schedulerUrl: "",
  expiresAt: "2026-08-22T23:59:59.000Z",
};

export const previewBootstrap: OnboardingBootstrap = {
  mode: "preview",
  client,
  answers: createEmptyAnswers(client),
  status: "invited",
  revision: 0,
};

const singleLocationClient = {
  ...client,
  clientId: "preview-northstar-single",
  locations: [client.locations[0]],
};

export const singleLocationPreviewBootstrap: OnboardingBootstrap = {
  mode: "preview",
  client: singleLocationClient,
  answers: createEmptyAnswers(singleLocationClient),
  status: "invited",
  revision: 0,
};
